import getAppRoot from '../../../utils/getAppRoot';
import resolveLastViewedDate from '../../../utils/resolveLastViewedDate';
import { Models } from '../../../App';
import { SchedulingQueryParams } from '../../constants';

const dateValidator = (self: Models['router'], queryParams: URLSearchParams) => {
  const isDateParamProvided = queryParams.has(SchedulingQueryParams.DATE);
  if (isDateParamProvided) {
    return {};
  }

  // Date is required, so override if missing — restore the last viewed day
  // (falling back to the workspace anchor date / today).
  return { [SchedulingQueryParams.DATE]: resolveLastViewedDate(getAppRoot(self).ui.selectedWorkspace) };
};

export default dateValidator;
